<template>
  <div class="details">
    <div class="card br-2">
      <div class="p-10">
        <div>
          <h6 class="fw-bold">REGISTRATION</h6>
          <div class="">
            <a href="" class="col-1 p-0 make-link" @click.prevent="expandAll()">Expand all</a>
            <span class="link_style"></span>
            <a href="" class="col-1 p-0 make-link" @click.prevent="collapseAll()">Collapse all</a>
          </div>
          <!-- 61129 : Verification setting info ---->
          <div v-if="!isOpenEnrollmentStudy" class="pt-8">
            <div>
              <i class="fa fa-plus-circle pr-6" v-if="!expandVerificationInfo" @click.prevent="expandVerificationInfo = true"></i>
              <i class="fa fa-minus-circle pr-6" v-if="expandVerificationInfo" @click.prevent="expandVerificationInfo = false"></i>
              Participant Verification Settings
            </div>
            <div v-if="expandVerificationInfo">
              <div class="card inner-card br-2">
                <div class="p-10">
                  <b-row class="pb-10">
                    <b-col>
                      <div class="header">
                        Verification Method
                      </div>
                      <div class="content">
                        <span>
                          {{ participantVerificationSetting }}
                        </span>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </div>
          <!-- 61129 : Verification setting info ---->
          <div class="pt-8">
            <div>
              <i class="fa fa-plus-circle pr-6" v-if="!expandParticipantInfo" @click.prevent="expandParticipantInfo = true"></i>
              <i class="fa fa-minus-circle pr-6" v-if="expandParticipantInfo" @click.prevent="expandParticipantInfo = false"></i>
              Participant Information Collected
            </div>
            <div v-if="expandParticipantInfo">
              <div class="card inner-card br-2">
                <div class="p-10">
                  <b-row class="pb-10" v-if="participantRequiredInfo.length > 0">
                    <b-col>
                      <div class="header">
                        Required
                      </div>
                      <div class="content">
                        <span v-for="(info, index) in participantRequiredInfo" :key="index">
                          {{ info }}
                          <span v-if="index + 1 < participantRequiredInfo.length">,</span>
                        </span>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="pb-10" v-if="participantOptionalInfo.length > 0">
                    <b-col>
                      <div class="header">
                        Optional
                      </div>
                      <div class="content">
                        <span v-for="(info, index) in participantOptionalInfo" :key="index">
                          {{ info }}
                          <span v-if="index + 1 < participantOptionalInfo.length">,</span>
                        </span>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </div>
          <div class="pt-8">
            <div>
              <i class="fa fa-plus-circle pr-6" v-if="!expandContactInfo" @click.prevent="expandContactInfo = true"></i>
              <i class="fa fa-minus-circle pr-6" v-if="expandContactInfo" @click.prevent="expandContactInfo = false"></i>
              Contact Information Collected
            </div>
            <div v-if="expandContactInfo">
              <div class="card inner-card br-2">
                <div class="p-10">
                  <b-row class="pb-10" v-if="contactRequiredInfo.length > 0">
                    <b-col>
                      <div class="header">
                        Required
                      </div>
                      <div class="content">
                        <span v-for="(info, index) in contactRequiredInfo" :key="index">
                          {{ info }}
                          <span v-if="index + 1 < contactRequiredInfo.length">,</span>
                        </span>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="pb-10" v-if="contactOptionalInfo.length > 0">
                    <b-col>
                      <div class="header">
                        Optional
                      </div>
                      <div class="content">
                        <span v-for="(info, index) in contactOptionalInfo" :key="index">
                          {{ info }}
                          <span v-if="index + 1 < contactOptionalInfo.length">,</span>
                        </span>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { map, filter } from "lodash";
/* 
IMPORTANT
Any changes made in this file should also be made in the registration-details.vue which is inside the study-details-pdf folder
 */
export default {
  name: "registration-details",
  data() {
    return {
      expandVerificationInfo: false,
      expandParticipantInfo: false,
      expandContactInfo: false
    };
  },
  components: {},
  props: {
    registrationDetails: {
      type: Array
    },
    studyData: {
      type: Object
    }
  },
  computed: {
    //TUR-61129 verification settings
    participantVerificationSetting() {
      return this.verificationMethod ? this.verificationMethod.text : "Email Only";
    },
    filteredRegistrationDetails() {
      return this.registrationDetails.map(item => {
        if (item.key === "verificationPhone") {
          item.field = "Verification Phone Number (Mobile)";
        }
        return item;
      });
    },
    verificationMethod() {
      if (this.studyData.verificationMethod) {
        if (this.studyData.verificationMethod === "email") {
          return { id: "email", text: "Email Only" };
        }
        if (this.studyData.verificationMethod === "phone") {
          return { id: "phone", text: "Phone Only" };
        }
        if (this.studyData.verificationMethod === "both") {
          return { id: "both", text: "Both ( Email and Phone )" };
        }
      }
      return null;
    },
    requiredIdFields() {
      return this.studyData.verificationMethod === "both" ? ["email", "verificationPhone", "password"] : this.studyData.verificationMethod === "phone" ? ["verificationPhone"] : ["email", "password"];
    },
    //TUR-61129 verification settings
    participantRequiredInfo() {
      return map(
        filter(this.filteredRegistrationDetails, o => {
          return o.type === "personalInfo" && (this.requiredIdFields.indexOf(o.key) !== -1 || (o.isOptional === "required" && o.isVisible === true));
        }),
        "field"
      );
    },
    participantOptionalInfo() {
      return map(
        filter(this.registrationDetails, o => o.type === "personalInfo" && o.isOptional === "optional" && o.isVisible === true),
        "field"
      );
    },
    contactRequiredInfo() {
      return map(
        filter(this.registrationDetails, o => o.type === "contactInfo" && o.isOptional === "required" && o.isVisible === true),
        "field"
      );
    },
    contactOptionalInfo() {
      return map(
        filter(this.registrationDetails, o => o.type === "contactInfo" && o.isOptional === "optional" && o.isVisible === true),
        "field"
      );
    },
    isOpenEnrollmentStudy() {
      return this.studyData.onboardingType.toLowerCase() == "openenrollment";
    }
  },
  methods: {
    expandAll() {
      this.expandVerificationInfo = true;
      this.expandParticipantInfo = true;
      this.expandContactInfo = true;
    },
    collapseAll() {
      this.expandVerificationInfo = false;
      this.expandParticipantInfo = false;
      this.expandContactInfo = false;
    }
  }
};
</script>

<style scoped>
.link_style {
  border-right: 1px solid #959fa4;
  margin: 0px 5px 0px 2px !important;
}
.inner-card {
  border: none;
  margin: 5px 20px;
  border-radius: 3px !important;
  background-color: #d3dfe4;
}
.header {
  font-size: 12px;
  color: #666669;
}
.content {
  font-size: 12px;
  font-weight: bold;
  color: #666669;
}
.make-link {
  color: #007bff !important;
}
</style>
